import React, { createContext, useContext, useState } from 'react';
import { api } from '../services/api';

interface TestModeContextType {
  testModeActive: boolean;
  setTestModeActive: (active: boolean) => void;
}

const TestModeContext = createContext<TestModeContextType>({
  testModeActive: false,
  setTestModeActive: () => {},
});

export function TestModeProvider({ children }: { children: React.ReactNode }) {
  const [testModeActive, setTestModeActiveState] = useState(false);

  function setTestModeActive(active: boolean) {
    setTestModeActiveState(active);
    // Persist to DB so email.ts reads the correct value
    api.admin.settings.update({ testModeActive: active }).catch(() => {});
  }

  return (
    <TestModeContext.Provider value={{ testModeActive, setTestModeActive }}>
      {children}
    </TestModeContext.Provider>
  );
}

export function useTestMode() {
  return useContext(TestModeContext);
}